import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { styled } from "@mui/system";
import Grid from "@mui/system/Grid";
import ContactInfo from "../../../_components/steps/ContactInfo";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Introduction from "../../../_components/steps/Introduction";
import { utilities } from "@/_helpers";
import Cookies from "universal-cookie";
import {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  clientProfiles,
  saveClientQuestionResponse,
  loadClientQuestionResponse,
} from "../../../_redux/actions/enrolleeActions";
import { useToaster } from "../../../_components/toaster/MuiToasterProvider";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Confirm from "../../../_components/steps/Confirm";
import LearnMore from "../../../_components/steps/LearnMore";
import Driver from "../../../_components/steps/Driver";
import WhyIsa from "../../../_components/steps/WhyIsa";
import Pricing from "../../../_components/steps/Pricing";
import VehicleInfo from "../../../_components/steps/VehicleInfos";
import LocationSchedule from "../../../_components/steps/LocationSchedule";
import WrapUp from "../../../_components/steps/WrapUp";
import ReadySpeed from "../../../_components/steps/ReadySpeed";
import { useParams, useNavigate } from "react-router-dom";
import {
  saveNewVehicle,
  loadVehicle,
} from "../../../_redux/actions/vehicleActions";
import {
  createAppointment,
  loadAppointments,
} from "../../../_redux/actions/appointmentActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { loadClientPaymentToken } from "../../../_redux/actions/paymentActions";
import ReferralModal from "../../../_components/steps/modal/ReferralModal";
import ChatBotIcon from "../../../_components/steps/ChatBody/ChatBotIcon";
import { logGeneralException } from "../../../_api/generalExceptionApi";

const progressBarStyles = {
  brand: {
    secondary: "#1c355e",
  },
};

const VEHICLE_SESSION_FIELDS = [
  "vehicleId",
  "VehicleId",
  "vehicleID",
  "VehicleID",
  "selectedVehicleID",
  "selectedVehicleId",
  "vehYear",
  "make",
  "model",
  "remoteStart",
  "pushStart",
  "engineClassId",
  "vin",
  "licensePlate",
  "issuingState",
  "color",
  "vehicleTrimId",
];

const resolveVehicleId = (enrolleeData = {}) =>
  enrolleeData?.vehicleId ??
  enrolleeData?.VehicleId ??
  enrolleeData?.vehicleID ??
  enrolleeData?.VehicleID ??
  enrolleeData?.selectedVehicleID ??
  enrolleeData?.selectedVehicleId;

const mergeLoadedEnrollee = (currentEnrollee = {}, loadedEnrollee = {}) => {
  const currentVehicleId = resolveVehicleId(currentEnrollee);
  const loadedVehicleId = resolveVehicleId(loadedEnrollee);
  const hasCurrentVehicle = Number(currentVehicleId) > 0;
  const hasLoadedVehicle = Number(loadedVehicleId) > 0;
  const shouldPreserveCurrentVehicle =
    hasCurrentVehicle &&
    (!hasLoadedVehicle || String(loadedVehicleId) === String(currentVehicleId));

  if (!shouldPreserveCurrentVehicle) {
    return { ...currentEnrollee, ...loadedEnrollee };
  }

  const preservedVehicleData = VEHICLE_SESSION_FIELDS.reduce(
    (vehicleData, field) => {
      if (Object.prototype.hasOwnProperty.call(currentEnrollee, field)) {
        vehicleData[field] = currentEnrollee[field];
      }
      return vehicleData;
    },
    {},
  );

  return {
    ...currentEnrollee,
    ...loadedEnrollee,
    ...preservedVehicleData,
    vehicleId: currentVehicleId,
    VehicleId: currentVehicleId,
    VehicleID: currentVehicleId,
    selectedVehicleID: currentVehicleId,
  };
};

const BorderLinearProgress = styled(LinearProgress)(() => ({
  // height: 36,
  borderRadius: 20,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#f1f5f9",
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: progressBarStyles.brand.secondary,
  },
  "& .MuiLinearProgress-bar": {
    borderRadius: 0,
    clipPath:
      "polygon(0 0, calc(100% - 12px) 0, calc(100% - 6px) 50%,calc(100% - 12px) 100%, 0 100%)",
  },
}));

const SpeedStory = ({
  enrolleeUpdate,
  registerEnrollee,
  saveEnrollee,
  clientUpdate,
  activeStep,
  setActiveStep,
  hasSetInitialStep,
  loadEnrollee,
  clientProfiles,
  saveClientQuestionResponse,
  saveNewVehicle,
  loadVehicle,
  createAppointment,
  loadAppointments,
  loadClientQuestionResponse,
  loadClientPaymentToken,
  isLoaded,
}) => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const toast = useToaster();
  const isMountedRef = useRef(null);
  // const [activeStep, setActiveStep] = useState(9);
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [submitting, setSubmitting] = useState(false);
  const STEPS = {
    DEVICE: "DEVICE",
    LOCATION_MAP: "LOCATION_MAP",
    LOCATION_ZIP: "LOCATION_ZIP",
    DATE_TIME: "DATE_TIME",
    SCHEDULE_NOW: "SCHEDULE_NOW",
  };
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const googleMapDataSession = JSON.parse(
    sessionStorage.getItem("googleMapData"),
  );
  const [pereferedContact, setPreferedContact] = useState(
    enrolleeUser?.contactPreference || "Phone",
  );
  // const langugeCode = localStorage?.getItem("i18nextLng");
  const [isEnrolleeLoadNeeded, setIsEnrolleeLoadNeeded] = useState(false);
  let enrolleeDataArray = useRef([]);
  const EnrollCookieData = cookies.get("EnrollNow") || {};
  const [openChatBot, setOpenChatBot] = useState(false);
  const showGetExpertIcon = true;

  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    Page:rawPage,
    URL,
  } = EnrollCookieData;
  // const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  let clientSaveResponse = null;
  const Page = rawPage?.substring(0, 150) || "";
  // const [scheduleType, setScheduleType] = useState("Location");
  const [stepSchedule, setStepSchedule] = useState(STEPS.SCHEDULE_NOW);
  const [flagDevice, setFlagDevice] = useState(false);
  const [referralModal, setReferralModal] = useState(false);
  const [deviceLocationType, setDeviceLocationType] = useState();
  const [appointmentData, setAppointmentData] = useState(null);
  let shouldSkipNextStep = false;

  const [answers, setAnswers] = useState([
    { questionCode: "DRIVEREXP", response: "" },
    { questionCode: "WHYISA", response: "" },
    { questionCode: "HOWSOONISA", response: "" },
  ]);
  const jwtTokenData = cookies.get("lifesaferEnrollment");
  const { storyName } = useParams();
  // let isSkipReady =
  //   (answers?.DRIVEREXP && answers?.HOWSOONISA && answers?.WHYISA && answers?.HOWSOONISA !== "60+ days" && answers?.HOWSOONISA !== "Undecided");
  let totalSteps = 5;
  const [ccToken, setCCToken] = useState(null);
  const skipConfirmStep = useRef(false);
  const navigate = useNavigate();
  const setGoogleMapData = (mapData) => {
    sessionStorage.setItem("googleMapData", JSON.stringify(mapData));
  };
  const isAbove1024 = useMediaQuery(theme.breakpoints.up(1024));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  // useEffect(() => {
  //   if (stepSchedule === STEPS.DATE_TIME) {
  //     setScheduleType("Calendar");
  //     return;
  //   }
  //   setScheduleType("Location");
  // }, [stepSchedule]);

  useEffect(() => {
    if (activeStep === 8) {
      sessionStorage.setItem("skipLocationScheduleInit", "1");
      setStepSchedule(STEPS.SCHEDULE_NOW);
    }
  }, [activeStep]);

  // useEffect(() => {
  //   if (stepSchedule === STEPS.DATE_TIME) {
  //     setScheduleType("Calendar");
  //     return;
  //   }
  //   setScheduleType("Location");
  // }, [stepSchedule]);

  const contactInfoForm = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      preferedContact: null,
      call_me_out: null,
      zip: enrolleeUser?.zip || null,
    },
  });

  const isShowExperienced =
    answers?.find((q) => q.questionCode === "DRIVEREXP")?.response ===
      "6-12 months" ||
    answers?.find((q) => q.questionCode === "DRIVEREXP")?.response ===
      "1+ year";

  const isTicketAccident =
    answers?.find((item) => item?.questionCode === "WHYISA")?.response ===
    "Ticket/crash";

  const goToNextStep = () => {
    if (activeStep >= 4 && !enrolleeUser?.showChatWidget) {
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify({
          ...enrolleeUser,
          showChatWidget: true,
        }),
      );
    }

    let nextStepValue = 1;
    if (activeStep === 8 && skipConfirmStep.current === true) {
      nextStepValue = 2;
      toast.error(t("toasts.noLocationPayment"));
    } else if (activeStep === 3 && isTicketAccident) {
      nextStepValue = 2;
    }
    setActiveStep(activeStep + nextStepValue);
  };

  //   if (!hasPaymentToken) {
  //   setActiveStep((prev) => prev + 2);
  //   toast.error(t("toasts.noLocationPayment"));
  // } else {
  //   goToNextStep();
  // }

  const goToBackStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }

    if (!Array.isArray(answers)) return;
    const whyIsa = answers?.find(
      (item) => item?.questionCode === "WHYISA",
    )?.response;

    if (whyIsa === "Ticket/crash") {
      setActiveStep((prev) => prev - 1);
    }
  };

  const logEnrollmentCodeException = async ({
    errorDetails,
    errorStatus,
    selectedPlan,
    brandIdentifier,
  }) => {
    const currentEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const selectedState =
      currentEnrolleeUser?.state || currentEnrolleeUser?.State || "N/A";
    const zipCode =
      currentEnrolleeUser?.zip || currentEnrolleeUser?.Zip || "N/A";
    const errorTitle =
      (typeof errorDetails === "object" && errorDetails?.title) ||
      errorDetails ||
      "Unknown error";
    const enrolleeId =
      currentEnrolleeUser?.enrolleeId ||
      currentEnrolleeUser?.EnrolleeId ||
      "N/A";
    const clientId =
      currentEnrolleeUser?.clientId ||
      currentEnrolleeUser?.ClientId ||
      currentEnrolleeUser?.clientID ||
      "N/A";

    await logGeneralException({
      portalId: 2,
      description:
        `Default Enrollment Code Issue. Status: ${errorStatus || "N/A"}; ` +
        `Error: ${errorTitle}; Selected State: ${selectedState}; ` +
        `ZIP Code: ${zipCode};` +
        `Selected Plan: ${selectedPlan?.name || "N/A"}; ` +
        `Fee Group: ${selectedPlan?.feeGroupName || "N/A"}; ` +
        `Brand: ${brandIdentifier || "N/A"}; Enrollee ID: ${enrolleeId}; ` +
        `Client ID: ${clientId};`,
      source: "Client Enrollment V2",
      fileName: "SpeedStory.jsx",
      functionName: "loadIsaEnrollmentCodeByState",
      notes: "Default enrollment code issue after Speed Story plan selection",
      addBy: currentEnrolleeUser?.userId || currentEnrolleeUser?.UserId,
      clientID:
        currentEnrolleeUser?.clientId ||
        currentEnrolleeUser?.ClientId ||
        currentEnrolleeUser?.clientID,
    });
  };

  const stepsInfo = [
    {
      name: "Introduction",
      title: "",
      description: null,
      progressBarValue: null,
    },
    {
      name: "Contact",
      title: t("steps.aboutYou"),
      description: t("steps.aboutMessage"),
      progressBarValue: 0,
    },
    {
      name: "Learn",
      title: t("speed.learnMoreTitle"),
      description: null,
      progressBarValue: 25,
    },

    {
      name: "Driver",
      title: t("speed.driverTitle"),
      description: t("speed.driverDescription"),
      progressBarValue: 30,
    },

    {
      name: "ISA",
      title: isShowExperienced
        ? t("speed.reinforceSafeTitle")
        : t("speed.buildSafeTitle"),
      description: null,
      progressBarValue: 45,
    },

    {
      name: "Pricing",
      title: t("speed.pricingTitle"),
      description: null,
      progressBarValue: 50,
    },
    {
      name: "Vehicle",
      title: t("steps.yourVehicle"),
      description: null,
      progressBarValue: 60,
    },

    {
      name: "Ready",
      title: "",
      description: null,
      progressBarValue: null,
    },

    {
      name: "Schedule",
      title: "",
      // scheduleType === "Location"
      //   ? t("steps.selectServiceCenter")
      //   : t("steps.selectInstallationDate"),
      description: null,
      progressBarValue: 80,
    },

    {
      name: "Confirmation",
      title: t("speed.autoPaySignupTitle"),
      description: t("steps.confirmDescription"),
      progressBarValue: 90,
    },

    {
      name: "Wrapup",
      title: null,
      description: null,
      progressBarValue: null,
    },
  ];

  useEffect(() => {
    if (isEnrolleeLoadNeeded === true && jwtTokenData?.jwtToken) {
      const reloadEnrollee = async () => {
        const currentSessionEnrollee =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        if (
          currentSessionEnrollee?.clientId !== undefined &&
          currentSessionEnrollee?.userId !== undefined
        ) {
          try {
            const enrolleeData = await loadEnrollee(
              currentSessionEnrollee?.clientId,
              currentSessionEnrollee?.userId,
            );
            if (enrolleeData) {
              const mergedEnrollee = mergeLoadedEnrollee(
                currentSessionEnrollee,
                enrolleeData,
              );
              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...mergedEnrollee,
                  HearAboutID:
                    enrolleeData?.HearAboutID ??
                    currentSessionEnrollee?.HearAboutID ??
                    null,
                  HearAboutName:
                    enrolleeData?.HearAboutName ??
                    currentSessionEnrollee?.HearAboutName ??
                    null,
                }),
              );

              if (enrolleeData?.contactPreference) {
                setPreferedContact(enrolleeData?.contactPreference);
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsEnrolleeLoadNeeded(false);
          }
        }
      };

      reloadEnrollee();
    }
  }, [isEnrolleeLoadNeeded]);

  useEffect(() => {
    if ((enrolleeUser?.clientId || enrolleeUser?.ClientId) && activeStep > 8) {
      loadAppointments(enrolleeUser?.clientId || enrolleeUser?.ClientId)
        .then((x) => {
          setAppointmentData(x);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  }, [activeStep]);

  useEffect(() => {
    if (enrolleeUser?.clientId && jwtTokenData?.jwtToken) {
      loadClientQuestionResponse(enrolleeUser.clientId)
        .then((responseList) => {
          if (responseList?.length) {
            setAnswers((prev) =>
              prev.map((q) => {
                const found = responseList.find(
                  (r) => r.questionCode === q.questionCode,
                );
                return found ? { ...q, response: found.response } : q;
              }),
            );
          }
        })
        .catch((error) => console.error(error));
    }
  }, [enrolleeUser?.clientId]);

  useEffect(() => {
    if (
      enrolleeUser &&
      enrolleeUser?.step?.toLowerCase() == "confirm" &&
      (enrolleeUser?.story?.toLowerCase() === "ISA Volunteer" ||
        enrolleeUser?.story?.toLowerCase() === "speed")
    ) {
      loadClientPaymentToken(
        enrolleeUser?.clientId ||
          enrolleeUser?.ClientId ||
          enrolleeUser?.clientID,
      )
        .then((ccToken) => {
          setCCToken(ccToken?.cC_Token);
          if (ccToken?.cC_Token == null) {
            setActiveStep((prev) => prev + 1);
          }
        })
        .catch((error) => {
          console.log("Loading Payment Token failed! " + error);
        });
    }
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    let homeLat = null;
    let homeLong = null;
    if (
      isMountedRef.current &&
      enrolleeUser?.clientId &&
      jwtTokenData?.jwtToken
    ) {
      clientProfiles(enrolleeUser?.clientId)
        .then((x) => {
          sessionStorage.setItem("clientProfiles", JSON.stringify(x));
          if (x?.length > 0) {
            homeLat = x[0]?.homeLatitude;
            homeLong = x[0]?.homeLongitude;
          }
          const currentSessionEnrollee =
            JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
          sessionStorage.setItem(
            "enrolleeUser",
            JSON.stringify({
              ...currentSessionEnrollee,
              homeLat,
              homeLong,
            }),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
    return () => (isMountedRef.current = false);
  }, []);

  // useEffect(() => {
  //   if (howSoonISA !== "60+ days" && howSoonISA !== "Undecided") {
  //     setCurrentScreen("skip");
  //   }
  // }, [howSoonISA]);

  const handleReferalSubmit = () => {
    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const { isReferralModalSubmit, ...cleanEnrolleeUser } = storedEnrolleeUser;

    if (isReferralModalSubmit) {
      sessionStorage.setItem(
        "enrolleeUser",
        JSON.stringify(
          utilities.normalizeEnrolleeSessionData(cleanEnrolleeUser),
        ),
      );
    }

    setReferralModal(false);
    goToNextStep();
  };

  const handleUpdate = async (currentStep, updateData) => {
    if (currentStep === "Referral") {
      handleReferalSubmit();
      return;
    }
    // if (currentStep == "Schedule") {
    //   setAppointmentData(updateData);
    // }
    if (updateData) {
      setSubmitting(true);
    }

    enrolleeDataArray.current = {
      ...enrolleeDataArray.current,
      ...updateData,
    };

    const currentEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const enrolleeID =
      currentEnrolleeUser?.enrolleeId ||
      currentEnrolleeUser?.EnrolleeId ||
      enrolleeUser?.enrolleeId ||
      enrolleeUser?.EnrolleeId;
    const userId =
      currentEnrolleeUser?.userId ||
      currentEnrolleeUser?.UserId ||
      enrolleeUser?.userId ||
      enrolleeUser?.UserId;
    const clientId =
      currentEnrolleeUser?.clientId ||
      currentEnrolleeUser?.ClientId ||
      enrolleeUser?.clientId ||
      enrolleeUser?.ClientId;
    const jwtToken = jwtTokenData?.jwtToken;

    try {
      if (enrolleeID && jwtToken) {
        const enrolleData = {
          ...updateData,
          enrolleeId: enrolleeID,
          story: "ISA Volunteer",
          Step: currentStep,
          contactPreference: pereferedContact || "Phone",
          deviceType:
            storyName?.toLowerCase() === "speed"
              ? "Speed"
              : utilities?.deviceInfo(
                  updateData?.deviceType || enrolleeUser?.clientTypeId,
                )?.deviceType,
          utM_source: UTM_source || null,
          utM_medium: UTM_medium || null,
          utM_campaign: UTM_campaign || null,
          gA_clientid: GA_clientid || null,
          gclID: gclid || null,
          userAgent: UserAgent || null,
          ipAddress: IPAddress || null,
          wbraid: wbraid || null,
          gbraid: gbraid || null,
          fbclid: fbclid || null,
          fbp: fbp || null,
          ttclid: ttclid || null,
          rdt_cid: rdt_cid || null,
          page: Page || null,
          referURL: URL?.slice(0, 500) || null,
        };
        await enrolleeUpdate(enrolleData);
      }

      if (updateData?.isReferralModalSubmit && clientId) {
        const referralSessionData =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const preservedReferralFields = {
          HearAboutID:
            updateData?.HearAboutID ?? referralSessionData?.HearAboutID ?? null,
          HearAboutName:
            updateData?.HearAboutName ??
            referralSessionData?.HearAboutName ??
            null,
        };
        const referralClientUpdate = {
          ...referralSessionData,
          ...preservedReferralFields,
          ...updateData,
          ClientId: clientId,
          UserId: userId,
          EnrolleeId: enrolleeID,
          BrandIdentifier:
            updateData?.BrandIdentifier ||
            referralSessionData?.BrandIdentifier ||
            null,
          CellPhone:
            updateData?.CellPhone ||
            referralSessionData?.CellPhone ||
            referralSessionData?.cellPhone ||
            null,
          HomePhone:
            updateData?.HomePhone ||
            referralSessionData?.HomePhone ||
            referralSessionData?.homePhone ||
            null,
          Email:
            updateData?.Email ||
            referralSessionData?.Email ||
            referralSessionData?.email ||
            null,
          FirstName:
            updateData?.FirstName ||
            referralSessionData?.FirstName ||
            referralSessionData?.firstName ||
            null,
          LastName:
            updateData?.LastName ||
            referralSessionData?.LastName ||
            referralSessionData?.lastName ||
            null,
          contactPreference: pereferedContact || "Phone",
          story: "ISA Volunteer",
        };
        await clientUpdate(referralClientUpdate);
      }

      switch (currentStep) {
        case "Contact":
          try {
            const storedContactSessionData =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const preservedContactFields = {
              HearAboutID:
                updateData?.HearAboutID ??
                storedContactSessionData?.HearAboutID ??
                null,
              HearAboutName:
                updateData?.HearAboutName ??
                storedContactSessionData?.HearAboutName ??
                null,
            };

            if (!enrolleeID || !jwtToken) {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              await registerEnrollee({
                ...contactUpdateData,
                EnrollmentCode: "LIFESAFERDEFAULTISA",
              }).then(
                async (enrolleeRes) => {
                  cookies.set(
                    "lifesaferEnrollment",
                    JSON.stringify(enrolleeRes),
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                  let enrolleeData = {
                    ...contactUpdateData,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: enrolleeRes?.clientId,
                    story: "ISA Volunteer",
                    Step: currentStep,
                    utM_source: UTM_source || null,
                    utM_medium: UTM_medium || null,
                    utM_campaign: UTM_campaign || null,
                    gA_clientid: GA_clientid || null,
                    gclID: gclid || null,
                    userAgent: UserAgent || null,
                    ipAddress: IPAddress || null,
                    wbraid: wbraid || null,
                    gbraid: gbraid || null,
                    fbclid: fbclid || null,
                    fbp: fbp || null,
                    ttclid: ttclid || null,
                    rdt_cid: rdt_cid || null,
                    page: Page || null,
                    referURL: URL?.slice(0, 500) || null,
                  };
                  if (!enrolleeRes?.jwtToken) {
                    sessionStorage.setItem(
                      "enrolleeUser",
                      JSON.stringify(
                        utilities.normalizeEnrolleeSessionData(enrolleeRes),
                      ),
                    );

                    if (["TEXT", "EMAIL"].includes(enrolleeRes?.resetSent)) {
                      shouldSkipNextStep = true;
                      return navigate("/verify", {
                        state: {
                          enrollee: enrolleeRes,
                          lifeSaferUser: contactUpdateData,
                        },
                      });
                    }

                    if (enrolleeRes?.resetSent === "CALL") {
                      shouldSkipNextStep = true;
                      return navigate("/contact-page");
                    }
                  }

                  await enrolleeUpdate(enrolleeData);
                  let clientSaveUpdateData = {
                    ...contactUpdateData,
                    UserId: enrolleeRes?.userId,
                    EnrolleeId: enrolleeRes?.enrolleeId,
                  };
                  // comment for now
                  // if (enrollmentCodeData?.enrollmentCode !== "LIFESAFERDEFAULT") {
                  //   clientSaveResponse = await saveEnrollee(clientSaveUpdateData);
                  // }

                  clientSaveResponse = await saveEnrollee(clientSaveUpdateData);

                  let clientUpdateData = {
                    ...contactUpdateData,
                    UserId: clientSaveResponse?.userId,
                    EnrolleeId: clientSaveResponse?.enrolleeId,
                    ClientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "ISA Volunteer",
                  };
                  if (clientSaveResponse) {
                    await clientUpdate(clientUpdateData);
                  }

                  let enrolleeSessionUpdateData = {
                    userId: enrolleeRes?.userId,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "ISA Volunteer",
                  };

                  enrolleeSessionUpdateData = {
                    ...enrolleeSessionUpdateData,
                    ...contactUpdateData,
                  };

                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify(
                      utilities.normalizeEnrolleeSessionData({
                        ...enrolleeSessionUpdateData,
                      }),
                    ),
                  );
                },
              );
            } else {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              let clientUpdateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                Step: currentStep,
                story: "ISA Volunteer",
              };

              updateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                ...{ story: "ISA Volunteer" },
              };
              const sessionUpdateData = { ...updateData };
              delete sessionUpdateData.isReferralModalSubmit;

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify(
                  utilities.normalizeEnrolleeSessionData({
                    ...currentEnrolleeUser,
                    ...sessionUpdateData,
                  }),
                ),
              );
              if (clientId) {
                await clientUpdate(clientUpdateData);
              } else {
                clientSaveResponse = await saveEnrollee(clientUpdateData);
                if (clientSaveResponse) {
                  let clientUpdateData = {
                    ...updateData,
                    UserId: clientSaveResponse?.userId,
                    EnrolleeId: clientSaveResponse?.enrolleeId,
                    ClientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "ISA Volunteer",
                  };
                  await clientUpdate(clientUpdateData);

                  let dataClient = {
                    userId: clientSaveResponse?.userId,
                    enrolleeId: clientSaveResponse?.enrolleeId,
                    clientId: clientSaveResponse?.clientId,
                  };

                  sessionStorage.setItem(
                    "enrolleeUser",
                    JSON.stringify(
                      utilities.normalizeEnrolleeSessionData({
                        ...currentEnrolleeUser,
                        ...updateData,
                        ...dataClient,
                      }),
                    ),
                  );
                }
              }
            }

            setReferralModal(updateData?.isReferralModalSubmit ? false : true);
          } catch (error) {
            let errorMessage = JSON.parse(error.message);
            if (errorMessage?.errors?.EnrollmentCodeId[0]) {
              toast.error(errorMessage?.errors?.EnrollmentCodeId[0]);
            } else {
              let errMess = error.message;
              errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
              toast.error(errMess);
            }
            return;
          }
          break;
        case "LearnMore":
          break;
        case "Driver":
          try {
            const payload = {
              Step: "Driver",
              clientId: enrolleeUser?.clientId,
              responses: answers
                .filter((a) => a.questionCode && a.response)
                .map((a) => ({
                  questionCode: a.questionCode,
                  response: a.response,
                })),
            };
            await saveClientQuestionResponse(payload);
          } catch (error) {
            let errMess = error.message
              .split(":")
              .pop()
              .replace('"', "")
              .slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        case "Vehicle":
          try {
            if (!updateData) {
              const selectedVehicleSession =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
              const selectedVehicleId =
                selectedVehicleSession?.vehicleId ??
                selectedVehicleSession?.VehicleId ??
                selectedVehicleSession?.vehicleID ??
                selectedVehicleSession?.VehicleID ??
                selectedVehicleSession?.selectedVehicleID;

              if (Number(selectedVehicleId) > 0) {
                sessionStorage.setItem(
                  "enrolleeUser",
                  JSON.stringify({
                    ...selectedVehicleSession,
                    vehicleId: selectedVehicleId,
                    VehicleId: selectedVehicleId,
                    VehicleID: selectedVehicleId,
                    selectedVehicleID: selectedVehicleId,
                    step: "Vehicle",
                    Step: "Vehicle",
                  }),
                );
              }

              break;
            }
            const result = await saveNewVehicle(updateData);
            if (result) {
              const vehicleData = await loadVehicle(clientId, userId);

              const matchedVehicle = vehicleData?.find((vehicle) => {
                const vehicleId =
                  vehicle?.vehicleId ??
                  vehicle?.VehicleId ??
                  vehicle?.vehicleID ??
                  vehicle?.VehicleID;
                return String(vehicleId) === String(result);
              });
              const latestSessionEnrollee =
                JSON.parse(sessionStorage.getItem("enrolleeUser")) ||
                currentEnrolleeUser;
              const vehicleWithoutUserId = matchedVehicle
                ? { ...matchedVehicle }
                : {};
              delete vehicleWithoutUserId.userId;

              sessionStorage.setItem(
                "enrolleeUser",
                JSON.stringify({
                  ...latestSessionEnrollee,
                  ...updateData,
                  ...vehicleWithoutUserId,
                  vehicleId: result,
                  VehicleId: result,
                  VehicleID: result,
                  selectedVehicleID: result,
                  step: "Vehicle",
                  Step: "Vehicle",
                }),
              );
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;
        case "Schedule":
          updateData = {
            ...updateData,
            contactPreference: pereferedContact || "Phone",
            story: "ISA Volunteer",
             deviceType:
              enrolleeUser?.deviceType === "Interlock" ||
              enrolleeUser?.clientTypeId === 1
                ? "IID"
                : enrolleeUser?.deviceType === "Portable" ||
                    enrolleeUser?.clientTypeId === 5
                  ? "PAM"
                  : enrolleeUser?.deviceType === "Speed" ||
                      enrolleeUser?.clientTypeId === 6
                    ? "ISA"
                    : "IID",
          };

          try {
            const newAppointment = await createAppointment(updateData);

            const ccTokenRes = await loadClientPaymentToken(
              enrolleeUser?.clientId ||
                enrolleeUser?.ClientId ||
                enrolleeUser?.clientID,
            );

            setCCToken(ccTokenRes?.cC_Token);
            const hasPaymentToken = ccTokenRes?.cC_Token !== null;

            if (!hasPaymentToken) {
              skipConfirmStep.current = true;
            }

            if (newAppointment.appointmentID > 0) {
              let enrolleeDeviceType = "Speed";
              if (
                enrolleeUser?.clientTypeId === 1 ||
                enrolleeUser?.deviceType === "Interlock" ||
                enrolleeUser?.deviceType === "IID"
              ) {
                enrolleeDeviceType = "Interlock";
              } else if (
                enrolleeUser?.clientTypeId === 5 ||
                enrolleeUser?.deviceType === "Portable" ||
                enrolleeUser?.deviceType === "PAM"
              ) {
                enrolleeDeviceType = "Portable";
              }

              const nextStep = hasPaymentToken ? "Confirm" : "WrapUp";

              let enrolleeData = {
                ...updateData,
                enrolleeId: enrolleeID,
                clientId: clientId,
                Step: nextStep,
                complete: true,
                deviceType: enrolleeDeviceType,
                UTM_source: UTM_source || null,
                UTM_medium: UTM_medium || null,
                UTM_campaign: UTM_campaign || null,
                GA_clientid: GA_clientid || null,
                page: Page || null,
                referURL: URL?.slice(0, 500) || null,
              };

              await enrolleeUpdate(enrolleeData);
              toast.success(t("outro.apptSaveSuccess"));
            }
          } catch (error) {
            console.error("Error getting enrollment:", error);
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;

        case "WrapUp":
          break;
      }

      hasSetInitialStep.current = true;
      // comment for now
      // if (
      //   !(
      //     currentStep === "Contact" &&
      //     enrollmentCodeData?.enrollmentCode === "LIFESAFERDEFAULT"
      //   )
      // ) {
      //   setIsEnrolleeLoadNeeded(true);
      // }
      if (currentStep !== "Vehicle") {
        setIsEnrolleeLoadNeeded(true);
      }
    } catch (error) {
      let errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(t("toasts.updateFailed") + " " + errMess);
    } finally {
      setSubmitting(false);
    }
    if (updateData && updateData?.subStep === "7.5.2") {
      return;
    }
    if (currentStep === "Contact" && shouldSkipNextStep) {
      return;
    }
    if (currentStep === "Contact") {
      if (updateData?.isReferralModalSubmit) {
        goToNextStep();
      }
      return;
    }
    if (!shouldSkipNextStep) {
      goToNextStep();
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Introduction
            handleUpdate={handleUpdate}
            setActiveStep={setActiveStep}
            appointmentData={appointmentData}
          />
        );
      case 1:
        return (
          <>
            {/* <Typography sx={{ textAlign: "center" }}>
              {t("steps.aboutMessage")}
            </Typography> */}
            <ContactInfo
              setSubmitting={setSubmitting}
              submitting={submitting}
              goToBackStep={goToBackStep}
              contactInfoForm={contactInfoForm}
              pereferedContact={pereferedContact}
              setPreferedContact={setPreferedContact}
              handleUpdate={handleUpdate}
              isLoaded={isLoaded}
            />
          </>
        );
      case 2:
        return (
          <>
            <LearnMore
              setActiveStep={setActiveStep}
              submitting={submitting}
              handleUpdate={handleUpdate}
            />
          </>
        );

      case 3:
        return (
          <>
            <Driver
              submitting={submitting}
              goToBackStep={goToBackStep}
              setAnswers={setAnswers}
              answers={answers}
              handleUpdate={handleUpdate}
            />
          </>
        );
      case 4:
        return (
          <>
            <WhyIsa
              submitting={submitting}
              setActiveStep={setActiveStep}
              goToBackStep={goToBackStep}
              experienceType={answers}
              handleUpdate={handleUpdate}
            />
          </>
        );
      case 5:
        return (
          <>
            <Pricing
              submitting={submitting}
              setActiveStep={setActiveStep}
              goToBackStep={goToBackStep}
              handleUpdate={handleUpdate}
              onEnrollmentCodeError={logEnrollmentCodeException}
            />
          </>
        );

      case 6:
        return (
          <>
            <VehicleInfo
              setSubmitting={setSubmitting}
              submitting={submitting}
              goToBackStep={goToBackStep}
              handleUpdate={handleUpdate}
              goToNextStep={goToNextStep}
            />
          </>
        );
      case 7:
        return (
          <>
            <ReadySpeed
              setActiveStep={setActiveStep}
              handleUpdate={handleUpdate}
            />
          </>
        );
      case 8:
        return (
          <>
            <LocationSchedule
              submitting={submitting}
              handleUpdate={handleUpdate}
              setActiveStep={setActiveStep}
              setDeviceLocationType={setDeviceLocationType}
              deviceLocationType={deviceLocationType}
              isLoaded={isLoaded}
              STEPS={STEPS}
              stepSchedule={stepSchedule}
              setStepSchedule={setStepSchedule}
              setGoogleMapData={setGoogleMapData}
              flagDevice={flagDevice}
              setFlagDevice={setFlagDevice}
              googleMapDataSession={googleMapDataSession}
              flagClickReset={false}
              compactScheduleFlow
            />
          </>
        );
      case 9:
        return (
          <>
            <Confirm
              ccToken={ccToken}
              appointmentData={appointmentData}
              handleUpdate={handleUpdate}
            />
          </>
        );
      case 10:
        return (
          <>
            <WrapUp appointmentData={appointmentData} />
          </>
        );
    }
  };

  const ProgressBar = () => {
    // const progress = 20;
    const progress = stepsInfo[activeStep]?.progressBarValue;
    // const progress = 60;

    return (
      <Box position="relative" width="100%" sx={{ overflow: "hidden" }}>
        <BorderLinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: isMobileOrTablet ? 24 : 28,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 0.5,
            zIndex: 1,
          }}
        >
          <span
            style={{
              // fontWeight: "bold",
              fontSize: "20px",
              fontWeight: 600,
              background:
                progress == 50
                  ? "linear-gradient(to right, #fff 30%, #1c355e 33%)"
                  : "#1c355e",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: progress <= 50 ? "transparent" : "#fff",
            }}
          >
            {progress}%
          </span>
        </Box>

        {/* Chevron separators */}
        {[...Array(totalSteps - 1)].map((_, index) => {
          let leftPercent = ((index + 1) / totalSteps) * 100;

          if (leftPercent === 80 || leftPercent === 60) {
            // leftPercent = leftPercent - 0.2;
            leftPercent -= 1.2;
          }

          return (
            <Box
              key={index}
              sx={{
                position: "absolute",
                top: 0,
                left: `${leftPercent}%`,
                transform: "translateX(-50%)",
                height: "100%",
                display: "flex",
                alignItems: "center",
                pointerEvents: "none",
                width: "16px",
                overflow: "hidden",
                justifyContent: "center",
              }}
            >
              <ArrowForwardIosIcon
                sx={{
                  width: 90,
                  height: 90,
                  fill: "#fff",
                  transform: "scaleX(0.3)",
                  clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                }}
              />
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <>
      <ReferralModal
        setReferralModal={setReferralModal}
        referralModal={referralModal}
        goToNextStep={goToNextStep}
        handleUpdate={handleUpdate}
        pereferedContact={pereferedContact}
        STEPS={STEPS}
        setStepSchedule={setStepSchedule}
        setActiveStep={setActiveStep}
        setFlagDevice={setFlagDevice}
        handleReferalSubmit={handleReferalSubmit}
      />

      {enrolleeUser?.showChatWidget && (
        <ChatBotIcon
          setOpen={setOpenChatBot}
          open={openChatBot}
          showGetExpertIcon={showGetExpertIcon}
        />
      )}
      <Grid>
        {activeStep > 0 && stepsInfo[activeStep]?.name != "Wrapup" && (
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              background: "linear-gradient(to bottom, #d6f2c0, #fff)",
              // paddingTop: stepsInfo[activeStep]?.title ? "2.8rem" : "1rem",
              paddingTop:
                stepsInfo[activeStep]?.progressBarValue !== null
                  ? "24px"
                  : "0px",
              paddingLeft: "1.4rem",
              paddingRight: "1.4rem",
              gap: isMobileOrTablet ? 2 : 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                // paddingTop: "2.8rem",
                flexWrap: "wrap",
                width: isAbove1024 ? "80%" : "100%",
                // mt:1,
              }}
            >
              {stepsInfo[activeStep]?.progressBarValue !== null && (
                // <ArrowProgressBar />
                <ProgressBar />
              )}
            </Box>
            {stepsInfo[activeStep]?.title && (
              <Typography
                sx={{
                  color: "#1c355e",
                  fontWeight: "bold",
                  fontSize: "25px",
                  textAlign: "center",
                }}
              >
                {stepsInfo[activeStep]?.title}
              </Typography>
            )}
            {stepsInfo[activeStep]?.description && (
              <Typography
                sx={{
                  textAlign: "center",
                  width: activeStep == 9 && !isMobileOrTablet ? "62%" : "100%",
                }}
              >
                {stepsInfo[activeStep]?.description}
              </Typography>
            )}
          </Grid>
        )}

        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: activeStep === 0 ? "row" : "column",
            paddingX: activeStep === 8 ? "20px" : 0,
            mb: activeStep !== 7 ? "64px" : "0px",
          }}
        >
          {renderStepContent(activeStep)}
        </Grid>
      </Grid>
    </>
  );
};

SpeedStory.propTypes = {
  registerEnrollee: PropTypes.func,
  enrolleeUpdate: PropTypes.func,
  saveEnrollee: PropTypes.func,
  clientUpdate: PropTypes.func,
  loadEnrollee: PropTypes.func,
  setActiveStep: PropTypes.func,
  hasSetInitialStep: PropTypes.bool,
  activeStep: PropTypes.number,
  clientProfiles: PropTypes.func,
  saveClientQuestionResponse: PropTypes.func,
  saveNewVehicle: PropTypes.func,
  loadVehicle: PropTypes.func,
  createAppointment: PropTypes.func,
  loadAppointments: PropTypes.func,
  loadClientQuestionResponse: PropTypes.func,
  loadClientPaymentToken: PropTypes.func,
  isLoaded: PropTypes.bool,
};

const mapDispatchToProps = {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  clientProfiles,
  saveClientQuestionResponse,
  saveNewVehicle,
  loadVehicle,
  createAppointment,
  loadAppointments,
  loadClientQuestionResponse,
  loadClientPaymentToken,
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SpeedStory);
